// extracted by mini-css-extract-plugin
export default {"link":"CmsSubCategories-module__link-Dg79TR"};